var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #A48BF0;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.55,6.12v-3.12c0-.81-.33-1.59-.92-2.16C11.05.27,10.26-.03,9.44,0h-3.28c-.82-.03-1.61.27-2.19.84-.59.57-.92,1.35-.92,2.16v3.12C.98,6.85-.28,8.95.05,11.12l.95,5.77c.46,2.32,2.52,3.98,4.88,3.92h3.88c2.36.06,4.42-1.6,4.88-3.92l.95-5.77c.32-2.18-.96-4.28-3.04-5Zm-3.75,7.81l.21.62c.09.29.04.6-.13.84-.17.24-.45.39-.75.39h-.74c-.3,0-.58-.15-.75-.39-.17-.24-.22-.55-.13-.84l.21-.62c.11-.35.02-.73-.23-1-.57-.67-.51-1.67.13-2.27.64-.61,1.64-.61,2.28,0,.64.6.7,1.6.13,2.27-.26.27-.34.65-.23,1ZM4.55,5.78h.36s6.14.01,6.14.01v-2.79c-.04-.85-.76-1.51-1.61-1.48h-3.28c-.85-.03-1.57.63-1.61,1.48v2.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/LockClosed.8c9315b2183eef3ea3a92c785ef871a7.svg";
export { ForwardRef as ReactComponent };